
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2.98535 11.3293C2.6832 11.3293 2.43847 11.0891 2.43847 10.7924V8.59636H0.760926C0.533973 8.59636 0.350769 8.41648 0.350769 8.19366V4.07539C0.350769 3.2767 1.01112 2.62836 1.8246 2.62836H2.43847V0.77326C2.43847 0.476605 2.6832 0.236328 2.98535 0.236328H9.01465C9.3168 0.236328 9.56153 0.476605 9.56153 0.77326V2.62836H10.1754C10.9889 2.62836 11.6492 3.2767 11.6492 4.07539V8.19366C11.6492 8.41648 11.466 8.59636 11.2391 8.59636H9.56153V10.7924C9.56153 11.0891 9.3168 11.3293 9.01465 11.3293H2.98535ZM8.70154 10.485V7.57216H3.29846V10.485H8.70154ZM10.7892 4.07539V7.75203H9.56151V6.80837C9.56151 6.76408 9.5246 6.72783 9.47948 6.72783H2.52052C2.4754 6.72783 2.43849 6.76408 2.43849 6.80837V7.75203H1.21075V4.07539C1.21075 3.74249 1.48556 3.47268 1.82462 3.47268H10.1754C10.5144 3.47268 10.7892 3.74249 10.7892 4.07539ZM8.70154 2.62836V1.08065H3.29846V2.62836H8.70154ZM2.43982 4.75864C2.43982 4.99086 2.6326 5.18013 2.86912 5.18013H6.00002C6.23655 5.18013 6.42932 4.99086 6.42932 4.75864C6.42932 4.52641 6.23655 4.33714 6.00002 4.33714H2.86912C2.6326 4.33714 2.43982 4.52641 2.43982 4.75864Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Print',
    }) as DefineComponent
    </script>
    